var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu bm-3 d-flex" },
    [
      _c(
        "v-col",
        { attrs: { lg: "10" } },
        [
          _c(
            "v-tabs",
            [
              _c("v-tab", [_vm._v("マイ" + _vm._s(_vm.objectText))]),
              _vm._v(" "),
              _c("v-tab", [_vm._v(" " + _vm._s(_vm.objectText))]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }